import app from "../app.first";
import $ from "jquery";

app.IntroduceYourself = class extends app.Component {
	constructor($this) {
		super($this);
		$(() => this.onDocumentReady($this));
	}

	onDocumentReady($this) {
		function isEmpty(el) {
			return !$.trim(el.html());
		}
		$(".upload-wrapper").each(function () {
			$(this).change(function (e) {
				$(this).parent().find(".filename").html(e.target.files[0].name);
				$(this).css("margin-bottom", "50px");
			});
		});

		$(".button-dprimary").click(function (e) {
			let earlyReturn = false;
			if ($(".upload-exists").length) {
				return;
			}
			$(".filename").each(function () {
				if (!isEmpty($(this))) {
					earlyReturn = true;
				}
			});

			if (earlyReturn) {
				return;
			}
			e.preventDefault();
			$(".error").html("You must upload atleast one file to continue");
		});
	}
};
